import { render } from "./InvoiceSender.vue?vue&type=template&id=9b940a48"
import script from "./InvoiceSender.vue?vue&type=script&lang=js"
export * from "./InvoiceSender.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__